import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { loginWithTNT } from "../auth/googleAuth";
import { getAuthUser } from "../auth/googleAuth";

const LoginPage = () => {
  const navigate = useNavigate();
  const [userid, setUserid] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (getAuthUser()) {
      navigate("/home");
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await loginWithTNT(userid, password);
      if (data.status === "ok") {
        localStorage.setItem("tnt_userid", data.userid);
        localStorage.setItem("tnt_orgid", data.orgid);
        const orgname = data.orgs ? data.orgs.split("=")[1] || "" : "";
        localStorage.setItem("tnt_orgname", orgname.trim());
        navigate("/home");
      } else {
        const msg = data.errmsg || data.errormsg || "Login failed. Please try again.";
        alert(msg);
      }
    } catch (err) {
      alert("Network error. Please check your connection and try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ backgroundColor: "#111111" }}
    >
      <div
        className="rounded-2xl p-10 w-full max-w-sm flex flex-col items-center"
        style={{ backgroundColor: "#1c1c1c", border: "1px solid #2a2a2a" }}
      >
        {/* Logo */}
        <img
          src="https://www.trakntell.com/wp-content/uploads/2020/10/logo_footer.png"
          alt="Trakntell"
          className="h-10 object-contain mb-8"
        />

        {/* Heading */}
        <h1 className="text-2xl font-bold mb-1" style={{ color: "#ffffff" }}>Sign in</h1>
        <p className="text-sm mb-8 text-center" style={{ color: "#888888" }}>TCU Diagnostic Platform</p>

        {/* Yellow divider */}
        <div className="w-12 h-1 rounded-full mb-8" style={{ backgroundColor: "#ffc20e" }} />

        {/* Login Form */}
        <form onSubmit={handleLogin} className="w-full flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-xs font-medium" style={{ color: "#aaaaaa" }}>Username</label>
            <input
              type="text"
              value={userid}
              onChange={(e) => setUserid(e.target.value)}
              required
              autoComplete="username"
              placeholder="Enter your username"
              className="w-full px-4 py-3 rounded-xl text-sm outline-none"
              style={{
                backgroundColor: "#111111",
                border: "1px solid #2a2a2a",
                color: "#ffffff",
              }}
              onFocus={(e) => { e.currentTarget.style.borderColor = "#ffc20e"; }}
              onBlur={(e) => { e.currentTarget.style.borderColor = "#2a2a2a"; }}
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-xs font-medium" style={{ color: "#aaaaaa" }}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              placeholder="Enter your password"
              className="w-full px-4 py-3 rounded-xl text-sm outline-none"
              style={{
                backgroundColor: "#111111",
                border: "1px solid #2a2a2a",
                color: "#ffffff",
              }}
              onFocus={(e) => { e.currentTarget.style.borderColor = "#ffc20e"; }}
              onBlur={(e) => { e.currentTarget.style.borderColor = "#2a2a2a"; }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full px-4 py-3 rounded-xl font-semibold text-sm transition-colors mt-2"
            style={{
              backgroundColor: loading ? "#b38a0a" : "#ffc20e",
              color: "#000000",
              cursor: loading ? "not-allowed" : "pointer",
            }}
            onMouseEnter={(e) => { if (!loading) e.currentTarget.style.backgroundColor = "#e6ae00"; }}
            onMouseLeave={(e) => { if (!loading) e.currentTarget.style.backgroundColor = "#ffc20e"; }}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
